module.exports = __webpack_public_path__ + "static/media/cbs_raleigh_2.fc6b4063.png";